import { render } from "./AddCommentModal.vue?vue&type=template&id=70672dad"
import script from "./AddCommentModal.vue?vue&type=script&lang=js"
export * from "./AddCommentModal.vue?vue&type=script&lang=js"

import "./AddCommentModal.vue?vue&type=style&index=0&id=70672dad&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__